import Vue from 'vue'
import VueStorage from 'vue-ls'
import config from '@/config/defaultSettings'

// base library
import '@/core/antd'
import Viser from 'viser-vue'

// ext library
// import VueClipboard from 'vue-clipboard2'
// VueClipboard.config.autoSetContainer = true

Vue.use(Viser)

Vue.use(VueStorage, config.storageOptions)
// Vue.use(VueClipboard)
